<ng-container *transloco="let t">
  <div class="max-md flex divide-border-secondary max-md:flex-col max-md:divide-y md:divide-x">
    <div class="flex flex-1 flex-col gap-2 max-md:pb-3" [class.pr-3]="displayPatientsList">
      @if (patientEditionDisabled) {
        <div class="flex items-center gap-5" data-testid="patient-data">
          <pxc-patient-avatar [patient]="patient" [size]="Size.SMALL" />
          <pxc-patient-data data-testid="patient-details" [patient]="patient" [size]="Size.SMALL" />
        </div>
        <div size="m" tuiNotification>{{ t('Vous ne pouvez pas modifier le patient à cette étape.') }}</div>
      } @else {
        @if ($safeNavigationMigration(patientEditForm?.errors) | keyvalue; as errors) {
          <div appearance="negative" data-testid="error-alert" icon="@tui.triangle-alert" size="m" tuiNotification>
            {{ errors[0].value }}
          </div>
        } @else {
          @if ((selectIsGamEnabled$ | async) === true) {
            @if (patientEditForm.value.isGamLinked) {
              <div appearance="positive" data-testid="gam-linked-alert" icon="@tui.link" size="m" tuiNotification>
                {{ t('Le patient est rattaché à votre établissement.') }}
              </div>
            } @else {
              @if (!isPatientAnonymous) {
                <div appearance="warning" data-testid="gam-unlinked-alert" icon="@tui.unlink" size="m" tuiNotification>
                  {{ t("Le patient n'est pas rattaché à votre établissement.") }}
                </div>
              }
            }
          }
        }
        <pxc-patient-edit-form data-testid="patient-edit-form" [form]="patientEditForm" />
      }
    </div>

    @if (displayPatientsList) {
      <tui-scrollbar class="h-80 overflow-x-hidden md:w-80">
        <pxc-patient-search-list
          data-testid="patient-searched-list"
          [patients]="searchedPatients$ | async"
          (selectPatient)="selectPatient($event)" />
      </tui-scrollbar>
    }
  </div>

  @if (displayActionButtons) {
    <div class="mt-4 flex flex-wrap justify-between gap-2">
      <button
        appearance="outline"
        class="max-sm:w-full"
        data-testid="patient-cancel"
        tuiButton
        type="button"
        (click)="closeEdition()">
        {{ t('Annuler') }}
      </button>
      @let isLoading = isCheckingFormValidity$ | async;
      <button
        class="max-sm:order-first max-sm:w-full"
        data-testid="patient-confirm"
        tuiButton
        type="button"
        [disabled]="!patientEditForm.valid || isLoading"
        [loading]="isLoading"
        (click)="save()">
        {{ t('Enregistrer') }}
      </button>
    </div>
  }
</ng-container>
